<template>
  <BModal
    ref="modal"
    size="md"
    title="Confirm price change"
    ok-title="Confirm change"
    cancel-title="Cancel"
    ok-variant="primary"
    @ok="handleConfirm"
    @hidden="reset"
  >
    <template v-if="pending">
      <p>
        Change <strong>{{ pending.label }}</strong> from
        <strong>{{ formatAmount(pending.oldAmount) }}</strong>
        to <strong>{{ formatAmount(pending.newAmount) }}</strong
        >?
      </p>
      <BAlert show variant="warning" class="small mb-0">
        A new Stripe price will be created and the old one archived. Existing
        subscribers are unaffected.
      </BAlert>
    </template>
  </BModal>
</template>

<script>
import { BModal, BAlert } from "bootstrap-vue";

export default {
  name: "ConfirmPriceChangeModal",
  components: { BModal, BAlert },
  data() {
    return {
      pending: null // { priceId, label, oldAmount, newAmount }
    };
  },
  methods: {
    open(payload) {
      this.pending = payload;
      this.$refs.modal.show();
    },
    handleConfirm(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.pending) {
        this.$emit("confirm", this.pending);
      }
      this.$refs.modal.hide();
    },
    reset() {
      this.pending = null;
    },
    formatAmount(cents) {
      return new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD"
      }).format(cents / 100);
    }
  }
};
</script>
